export function getTextColor(number: number): string {
  return number > 0 ? 'text-success' : 'text-danger';
}
